var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-banners"},_vm._l((_vm.showActiveBanners),function(banner){return (_vm.currentLocation)?_c('active-banners',{key:banner.id,attrs:{"banner":banner}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }